let init = {
    getAllQuickChat: {
        list: [],
        totalDocs: 0,
        totalPages: 0,
        limit: 10,
        page: 0,
    },
};

const quickChatReducer = (state = init, { type, payload }) => {
    switch (type) {
        case "GET_QUICK_CHAT_LIST": {
            return {
                ...state,
                getAllQuickChat: {
                    list: payload?.docs,
                    totalDocs: payload?.totalDocs,
                    totalPages: payload?.totalPages,
                    limit: payload?.limit,
                    page: payload?.page - 1,
                },
            };
        }
        default: {
            return state;
        }
    }
};

export default quickChatReducer;
